module.exports = __webpack_public_path__ + "img/idcardz.c630be42.png";